<div class="container-fluid">
  <div class="page-header">
    <h1 class="page-title">{{ tituloPagina }}</h1>
    <p class="page-subtitle">Preencha os campos obrigatórios para salvar o microserviço.</p>
  </div>

  <div class="form-card">
    <form [formGroup]="formMicroservico" (ngSubmit)="onSubmit()" class="microservico-form">
      <div class="form-row">
        <div class="form-group">
          <label for="item">Item *</label>
          <input
            type="text"
            id="item"
            class="form-control"
            formControlName="item"
            placeholder="Digite o item">
          <small class="text-danger" *ngIf="isFieldInvalid('item')">
            {{ getFieldError('item') }}
          </small>
        </div>

        <div class="form-group">
          <label for="descricao">Descrição *</label>
          <input
            type="text"
            id="descricao"
            class="form-control"
            formControlName="descricao"
            placeholder="Digite a descrição">
          <small class="text-danger" *ngIf="isFieldInvalid('descricao')">
            {{ getFieldError('descricao') }}
          </small>
        </div>
      </div>

      <div class="form-actions">
        <button type="button" class="btn btn-outline-secondary" (click)="cancelar()">Cancelar</button>
        <button type="button" class="btn btn-secondary" (click)="limparFormulario()">Limpar</button>
        <button type="submit" class="btn btn-primary" [disabled]="formMicroservico.invalid">
          Salvar
        </button>
      </div>
    </form>
  </div>
</div>